import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";
import { ProductSliderSources } from "@omni/types/components/product/enums/productSliderResource.enum";

import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { ProductSlider } from "@/components/Product/ProductSlider/productSlider.container";
import { LayoutSettings } from "@/utils/swiper.utils";

type AccessoriesSliderProps = {
    sku: string;
    prefetchedData?: Array<Product<ProductFieldSet.ProductTile>>;
    productSource:
        | ProductSliderSources.MainProduct
        | ProductSliderSources.Accessory;
    title: string;
    breakpointsLayoutSettings: LayoutSettings;
};

const RelatedProductsSliderComponent = ({
    sku,
    prefetchedData,
    productSource,
    title,
    breakpointsLayoutSettings
}: AccessoriesSliderProps) => {
    return (
        <section>
            <Row>
                <Col>
                    <div>
                        <ProductSlider
                            title={title}
                            sku={sku}
                            source={productSource}
                            productTileConfig={{
                                amountOfFeatures: 0,
                                useInsidePadding: false,
                                showButton: false,
                                showCategoryLink: false,
                                allowInstantAddToCart: false
                            }}
                            breakpointsConfig={{
                                hidden: [],
                                layoutSettings: breakpointsLayoutSettings
                            }}
                            prefetchedProducts={prefetchedData}
                        />
                    </div>
                </Col>
            </Row>
        </section>
    );
};

export { RelatedProductsSliderComponent };
